import { useEffect, useState } from 'react'

// useWaitingState is a hook that can be used to show a waiting state for a certain amount of time.
// when setIsWaiting is set to true, the waiting state will be shown for the specified amount of time.
export default function useWaitingState(initialState = false, timeInMs = 1500) {
  const [isWaiting, setIsWaiting] = useState(initialState)

  useEffect(() => {
    if (isWaiting) {
      const timeout = setTimeout(() => {
        setIsWaiting(false)
      }, timeInMs)

      return () => {
        clearTimeout(timeout)
      }
    }
    return () => {
      // do nothing
    }
  }, [isWaiting, timeInMs])

  return [isWaiting, setIsWaiting] as const
}
